<ideal-cart-item-quantity-selector [itemId]="id()" sellMultipleHints="false" *renderInItemResult="LayoutTargets.Actions" />
